const header = document.getElementById('sticky-header--js')
const content = document.getElementById('content')
const stickyContainer = document.querySelector('.header .container')
const stickyCompensation = document.querySelector('.sticky-compensation')
const metaContainer = document.querySelector('.meta-container')
const headerOffset = header.offsetTop
let lastKnownScrollPosition = 0
let ticking = false


// 304 - 128 = 176 diff of sticky and non-sticky header

const toggleSticky = () => {

  console.log(lastKnownScrollPosition)

  if (window.innerWidth < 1024) {
    return
  }

  if (lastKnownScrollPosition > 176) {
    content.setAttribute(
      'style',
      `margin-top: 304px`
    )

    header.classList.add('scrolled')
  } else {
    content.removeAttribute('style')
    header.classList.remove('scrolled')
  }

  // if (window.scrollY > headerOffset) {
  //   const offset = stickyContainer.offsetHeight + metaContainer.offsetHeight
  //   header.classList.add('sticky')
  //   const mediaQuery = window.matchMedia('(min-width: 48rem)')
  //   if (mediaQuery.matches) {
  //     stickyCompensation.setAttribute(
  //       'style',
  //       `height: ${offset}px`
  //     )
  //   }
  // } else {
  //   header.classList.remove('sticky')
  //   stickyCompensation.removeAttribute('style')
  // }
}

document.addEventListener('scroll', (e) => {
  lastKnownScrollPosition = window.scrollY

  if (!ticking) {
    window.requestAnimationFrame(() => {
      toggleSticky(lastKnownScrollPosition)
      ticking = false
    })

    ticking = true
  }
}, {passive: true})

export default toggleSticky;
